import React from "react"

import { RouteComponentProps } from "react-router-dom"
import { gql, useQuery } from "urql"

import { Color } from "~tailwindui/types/enums"

import NotFound from "~Tutor/Pages/NotFound"
import { path } from "~Tutor/TutorRoutes"
import { H1, StyledLink, WithLoadingIndicator } from "~tailwindui/Basics"

import { MatchParams } from "src/types/MatchParams"

import PieChart from "components/TailoredSectionResultChart"

const TailoredAssignmentResults: React.FC<RouteComponentProps<MatchParams>> = ({
  match,
}) => {
  const { id: tailoredAssignmentId, studentId } = match.params

  const [result] = useQuery({
    query: loadResultsQuery,
    variables: { tailoredAssignmentId, studentId },
  })

  if (
    result.data &&
    (!result.data.tailoredAssignment || !result.data.tailoredSectionSummaries)
  )
    return <NotFound />

  return (
    <WithLoadingIndicator
      result={result}
      error="An error occurred while loading assignment results"
    >
      {({ data }) => {
        const chartData = data.tailoredSectionSummaries
          .map(tailoredSectionSummary => {
            const score = `${(
              tailoredSectionSummary.studentScore * 100
            ).toFixed(2)}%`
            return {
              sectionId: tailoredSectionSummary.tailoredSection.id,
              sectionReviewPath: path("studentTailoredSectionDetails", {
                studentId,
                tailoredAssignmentId,
                id: tailoredSectionSummary.tailoredSection.id,
              }),
              label: `${tailoredSectionSummary.tailoredSection.name}\n${score}`,
              data: [
                { x: "Correct", y: tailoredSectionSummary.correctCount },
                { x: "Incorrect", y: tailoredSectionSummary.incorrectCount },
              ].filter(d => d.y > 0),
            }
          })
          .filter(d => d.data.length > 0)

        return (
          <React.Fragment>
            <H1 className="text-center">
              Results for {data.tailoredAssignment.name}
            </H1>
            <div className="row">
              {chartData.map(chartData => (
                <div className="center w-1/2" key={chartData.sectionId}>
                  <PieChart chartData={chartData} />
                  <div>
                    <StyledLink
                      to={path("studentTailoredSectionDetails", {
                        studentId,
                        tailoredAssignmentId,
                        id: chartData.sectionId,
                      })}
                      button
                      color={Color.Orange}
                    >
                      Review Answers
                    </StyledLink>
                  </div>
                </div>
              ))}
            </div>
          </React.Fragment>
        )
      }}
    </WithLoadingIndicator>
  )
}

const loadResultsQuery = gql`
  query TailoredAssignmentResults($tailoredAssignmentId: ID!, $studentId: ID!) {
    tailoredAssignment(id: $tailoredAssignmentId) {
      name
    }
    tailoredSectionSummaries(
      tailoredAssignmentId: $tailoredAssignmentId
      studentId: $studentId
    ) {
      correctCount
      incorrectCount
      skippedCount
      studentScore
      reviewPath
      tailoredSection {
        id
        name
      }
    }
  }
`

export default TailoredAssignmentResults
